import type {LibraryComponent} from '../../components/allspice_render/library_component.ts';
import type {ProjectPageDiff} from './file_tree.ts';
import type {ProjectData} from './project-data.ts';

type EmptyPreview = {
  ty: 'empty';
  path: string;
};

export type LoadingPreview = {
  ty: 'loading';
  path: string;
  previewPromise: Promise<Preview | void>;
};

export type ErrorPreview = {
  ty: 'error';
  path: string;
  message: string;
};

export type FileDiffPreview = {
  ty: 'file-diff';
  path: string;
  html: Node;
  commentHtml?: HTMLElement | null;
  variantHtml?: Node;
  warnings?: any[];
};

export type ProjectPageDiffPreview = {
  ty: 'proj-page-diff';
  file: ProjectPageDiff;
  pageComponent: LibraryComponent | null;
  isDiffLoadedPromise: Promise<[any, any]> | null;
  commentHtml?: HTMLElement | null;
  variantHtml?: Node | null;
  projectData?: ProjectData;
  nets?: Record<string, {id: string; name: string}>;
};

export type Preview = EmptyPreview | LoadingPreview | ErrorPreview | FileDiffPreview | ProjectPageDiffPreview;

export function emptyPreview(): EmptyPreview {
  return {ty: 'empty', path: ''};
}

export function loadingPreview(path: string, promise: Promise<Preview | void>): LoadingPreview {
  return {ty: 'loading', path, previewPromise: promise};
}

export function errorPreview(path: string, message: string): ErrorPreview {
  return {ty: 'error', path, message};
}

export function fileDiffPreview(path: string, html: Node, variantHtml?: Node, warnings?: any[]): FileDiffPreview {
  return {ty: 'file-diff', path, html, variantHtml, warnings};
}

export function isFileDiff(preview: Preview): preview is FileDiffPreview {
  return (preview as FileDiffPreview).ty === 'file-diff';
}

export function isProjectPageDiff(preview: Preview): preview is ProjectPageDiffPreview {
  return (preview as ProjectPageDiffPreview).ty === 'proj-page-diff';
}
